// soups-featuring.js — Loads Soups Featuring section on ingredient pages
(function(){
  var SOUP_NAMES = {
    'optigrow':'Optigrow','seeingood':'SeeInGood',
    'nosneezy':'NoSneezy','excellunng':'Excellunng',
    'heshouwu':'HeShouWu','pepperwarm':'Pepperwarm',
    'aligo':'Aligo','bazhenjie':'BaZhenJie',
    'good9':'Good 9','gobeauty':'Go Beauty',
    'getfit':'GetFit/GetSlim','seeinclear':'SeeInClear',
    'bemindii':'BeMindii','cowecare':'CoWeCare',
    'proticare':'Proticare','onitecare':'Onitecare',
    'essenceqi':'EssenceQi','gautaway':'Gautaway','mintikis':'Mintikis'
  };
  var SOUP_NAMES_ZH = {
    'optigrow':'真高宝','seeingood':'亮睛宝',
    'nosneezy':'舒鼻宝','excellunng':'舒肺宝',
    'heshouwu':'何首乌','pepperwarm':'砂胡椒',
    'aligo':'阿里哥','bazhenjie':'八珍姐',
    'good9':'好享睡','gobeauty':'好享靓',
    'getfit':'好享瘦','seeinclear':'亮睛睛',
    'bemindii':'益智补','cowecare':'疫后补',
    'proticare':'健肌补','onitecare':'熬夜补',
    'essenceqi':'益补气','gautaway':'不痛风','mintikis':'口芬芳'
  };

  function initSoups(){
    var section = document.getElementById('soups-section');
    var grid    = document.getElementById('soups-grid');
    if(!section || !grid) return;
    // Static cards are rendered server-side in the page body — never wipe them.
    if(grid.children.length){ section.style.display=''; return; }

    // Get ingredient tag from page scripts
    var tag = null;
    var all = document.querySelectorAll('script');
    for(var i=0;i<all.length;i++){
      var t = all[i].textContent || all[i].text || '';
      var m = t.match(/var tag='([^']+)'/);
      if(m){ tag = m[1]; break; }
    }
    if(!tag){ section.dataset.loaded=''; return; }

    // Detect locale from html lang attribute
    var lang = document.documentElement.lang || 'en';
    var isZh = lang.indexOf('zh') === 0;

    fetch('/collections/all/products.json?limit=250')
      .then(function(r){ return r.json(); })
      .then(function(data){
        var products = (data.products||[]).filter(function(p){
          return p.images && p.images.length &&
                 (/^(soupermum|souperkid|souperdad)/.test(p.handle) ||
                  p.handle==='essenceqi' || p.handle==='gautaway' || p.handle==='mintikis') &&
                 p.handle.indexOf('seven2me') === -1 &&
                 p.tags.indexOf(tag) !== -1;
        });
        if(!products.length){ section.dataset.loaded=''; return; }
        section.style.display = '';
        grid.innerHTML = products.map(function(p){
          var name = isZh && SOUP_NAMES_ZH[p.handle] ? SOUP_NAMES_ZH[p.handle] : (SOUP_NAMES[p.handle] || p.title);
          var img  = p.images[0] ? p.images[0].src : '';
          return '<a href="/products/'+p.handle+'" class="product-card" '+
              'style="display:block;text-decoration:none;cursor:pointer;">'+
            (img ? '<div class="product-card-img"><img src="'+img+'" alt="'+name+'" loading="lazy"></div>' : '')+
            '<div class="product-card-body" style="text-align:center;display:flex;flex-direction:column;align-items:center;gap:8px;padding:12px 14px 16px;">'+
            '<h3 style="font-size:15px;color:#00788a;font-weight:700;margin:0">'+name+'</h3>'+
            '<span style="display:inline-block;font-size:12px;font-weight:700;color:#fff;'+
              'background:#00788a;border:1.5px solid #00788a;padding:5px 16px;border-radius:20px;">Shop Now</span>'+
            '</div></a>';
        }).join('');
      }).catch(function(){ section.dataset.loaded=''; });
  }

  // Run on current page
  function tryInit(){ setTimeout(initSoups, 200); }
  tryInit();

  // Watch for AJAX navigation — observe DOM changes for soups-section appearing
  if(window.MutationObserver){
    var observer = new MutationObserver(function(){ tryInit(); });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  // Also handle popstate (back/forward)
  window.addEventListener('popstate', tryInit);
  // Shopify theme navigation events
  document.addEventListener('page:load', tryInit);
  document.addEventListener('page:change', tryInit);

  // Fix CTA banner: ensure button is centered + fix old domain URL
  var ctaBanner = document.querySelector('.cta-banner');
  if(ctaBanner){
    ctaBanner.style.display='flex';
    ctaBanner.style.flexDirection='column';
    ctaBanner.style.alignItems='center';
    ctaBanner.style.textAlign='center';
    // Fix old my.foodartstore.com links to use /collections
    var ctaLink = ctaBanner.querySelector('a.cta-btn');
    if(ctaLink && ctaLink.href.indexOf('my.foodartstore.com')>-1){
      ctaLink.href='/collections/all';
      ctaLink.removeAttribute('target');
    }
  }
})();
